import './style.scss';

const faqToggle = () => {
  const targets = document.querySelectorAll('.wp-block-ths-blocks-q-and-a-item');

  if (!targets) return;

  const removeClass = () => {
    Array.from(targets).forEach((target) => {
      if (target.classList.contains('is-active') === true) {
        target.classList.remove('is-active');
      }
    });
  }

  Array.from(targets).forEach((target) => {
    target.addEventListener('click', () => {
      if (target.classList.contains('is-active') === true) {
        target.classList.remove('is-active');
      } else {
        removeClass();
        target.classList.add('is-active');
      }
    });
  });
}

faqToggle();